module.exports = __webpack_public_path__ + "static/media/alfa.52fe7911.svg";